import Marquee from "react-fast-marquee";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t-[3px] border-[#FFFDF5]/10">
      {/* Big marquee name */}
      <div className="py-6 overflow-hidden border-b border-[#FFFDF5]/10">
        <Marquee speed={40} gradient={false} direction="right" autoFill>
          <span className="font-heading text-5xl md:text-7xl uppercase tracking-tighter mx-8 text-[#FFFDF5]/5">
            CORCORAN DESIGN
          </span>
        </Marquee>
      </div>

      <div className="px-6 md:px-12 lg:px-24 py-8 text-center">
        <p className="font-mono text-xs uppercase tracking-widest text-[#525252]">
          {year} Connor Corcoran. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
